var mentor_confirm_details_form = (function( $ ) {

	var $form;

	var _init = function() {
		$form = $( '#mentor_confirm_details_form' );

		if ( $form.length > 0 ) {
			$form.on( 'pre_submission', _pre_submission );
		}
	};

	var _pre_submission = function( e, trigger_el ) {
		var $trigger_el = $( trigger_el );
		var answer = '';

		if ( $trigger_el.hasClass( 'accept' ) ) {
			answer = 'accept';
		} else if ( $trigger_el.hasClass( 'decline' ) ) {
			answer = 'decline'
		} else if ( $trigger_el.hasClass( 'postpone' ) ) {
			answer = 'postpone';
		}

		$form.find( '#field_answer' ).val( answer );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = mentor_confirm_details_form;